//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmUmisteniSpisovyUzelDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-06                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(sslsumi) GID:(Web.Set.Des.Ts) V1:(ixs_su,umisteni,umisteni_nad,aktivita,poznamka,dat_zmena,zmenu_prov,umisteni_txt,priz_oper,ixs_fun_zodp) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmUmisteniSpisovyUzelDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdmUmisteniSpisovyUzelDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_su */
            public ixs_su: string;
            /** PK - umisteni */
            public umisteni: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmUmisteniSpisovyUzelListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>, ixs_su: string,umisteni: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_su, umisteni);
            v_form.addRow("jres:30011603").addField("gselectbox", Gordic.Prefabs.Select.sslsump(), {
                dropdown: true,
                name: "umisteni",
                initialValue: { umisteni: umisteni },
                model: "model.umisteni=value.umisteni",
                disabled: umisteni ? true : false
            })
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>, ixs_su: string,umisteni: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>, ev, ctx): any {
            var filterObj = {
                umisteni: SeznamBase.filterContains(ctx.filter, "umisteni")
            }
            that.view = new Gordic.Isl.View(that.isl.AdmUmisteniSpisovyUzel.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmUmisteniSpisovyUzelDesignerInit
         * 
         * @param {GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>} that
         */
        static SeznamAdmUmisteniSpisovyUzelDesignerInit(that: GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>, ixs_su: string,umisteni: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_su,umisteni);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_su, umisteni);
        } // SeznamAdmUmisteniSpisovyUzelDesignerInit

        static LoadData(that: GContentType<SeznamAdmUmisteniSpisovyUzelDesigner>, ixs_su: string, umisteni: string) {
            var filterObj: any = {};
            if (umisteni) {
                new Gordic.Data.Readers.Sslsump().getData({ umisteni: umisteni }).done((o) => {
                    that.filter.findFields("umisteni").gfield("setValue", o[0]);
                })
                filterObj.umisteni = umisteni;
            }
            that.view = new Gordic.Isl.View(that.isl.AdmUmisteniSpisovyUzel.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }
    }
}
